// extracted by mini-css-extract-plugin
module.exports = {"container":"ContentBox_container__1URek"};